import { ElementType } from 'react';

import {
  CartItemOnlineFulfillmentEnum,
  ExtendedPackageCartItemDetails
} from './cart.types';

export interface LocationPackageItem {
  id: number;
  price_orig: number;
  price: number;
  name: string;
  category: string;
  dscr_line: string | null;
  tax_amt: number;
  taxable: number;
  pg_require: number;
  pg_master_id: number;
  is_pkg_master: number;
  store_is_avail: number;
  store_avail_list: string;
  qty?: number;
}

export type ExtendedLocationPackageItem = LocationPackageItem & {
  qty: number;
  store_id: number;
  amount?: number;
  amount_total?: number;
  tax_amount_total?: number;
  amount_orig?: number;
  online_fulfillment: CartItemOnlineFulfillmentEnum;
};

export interface LocationPackageInterface {
  id: number;
  name: string;
  category: string;
  dscr_line: string | null;
  is_pkg_master: number;
  pkg_list: LocationPackageItem[];
}

export type SelectedPackage =
  | ExtendedLocationPackageItem
  | ExtendedPackageCartItemDetails;

export interface RecipientValuesInterface {
  to: string;
  from: string;
  message: string;
  isForMe: boolean;
  email?: string;
}

export interface CheckValuesInterface {
  variant: string;
  email: string;
  newEmail: string;
  saveForFutureUse: boolean;
}

export enum Variants {
  EmailToMe = 'Email to me:',
  Download = 'Download only',
  NewEmail = 'New Email',
  SavedRecipientEmails = `Saved Recipient's Emails`
}

export enum BookingSteps {
  LOCATION,
  SERVICE,
  TIME,
  REVIEW,
  RECOMMENDED,
  SUCCESS
}

export enum BookServiceSteps {
  Services = 1,
  Addons = 2,
  Providers = 3
}

export enum MembershipShopSteps {
  LOCATION,
  LIST,
  PAYMENTS,
  TERMS,
  SUCCESS
}

export enum AccessStep {
  All = 'all',
  Public = 'public',
  None = 'none'
}

export type AccessStepType = AccessStep;

export interface GiftCardStep {
  mobileName: string;
  name: string;
  route: string;
  icon: ElementType;
  access: AccessStepType;
}
